<template>
    <div>
    <!--<v-layout column class="baleset-dij-box baleset-dij-box-fontsize ma-1">
        <v-flex sm12 xs12> <span key="'dij1'+this.biztosito_id">{{formatCurrency(this.evesdij)}}</span></v-flex>
        <v-flex sm12 xs12> <span key="'dij2'+this.biztosito_id">{{formatCurrency(this.gyakdij)}}</span></v-flex>
        <v-flex sm12 xs12> <span class="font-weight-bold">{{this.year}}. évben</span></v-flex>
    </v-layout>-->

    <v-layout column class="baleset-dij-box ma-1">

        <v-flex sm12 xs12 class="gyakorisagi-dij-text currency">

                <v-flex style="padding-top:10px;">
                    <span class="ezer currency">
                        {{ getDijEzresek(this.evesdij) }}
                    </span>&nbsp;
                    <span
                        class="szaz currency">
                        {{getDijSzazasok(this.evesdij)}}
                    </span>&nbsp;
                    <span class="currency" style="font-size:12px;">Ft /&nbsp;{{getEvNev()}}</span>
                </v-flex>

                <!--<v-flex>
                    <v-layout column style="margin-top:5px;">
                        <v-flex sm12 xs12 class="ezer currency">
                            {{ getDijEzresek(this.evesdij) }}
                        </v-flex>
                        <v-flex sm12 xs12 class="szaz currency">
                        &nbsp;{{getDijSzazasok(this.evesdij)}}&nbsp;Ft
                        </v-flex>
                        <v-flex sm12 xs12 class="currency"
                        style="font-size:12px; margin-top:-10px;">{{getGyakNev()}}</v-flex>
                    </v-layout>
                </v-flex>-->

        </v-flex>

        <v-flex sm12 xs12 class="yearly-fee-text evesdij-text currency">
            <span class="evesdij-txt">
                {{getDijEzresek(this.gyakdij)}}&nbsp;{{getDijSzazasok(this.gyakdij)}}&nbsp;Ft{{getGyakNev()}}
            </span>
        </v-flex>

        <v-flex sm12 xs12 class="mb-2" style="background: transparent; border-radius: 4px;">
            <span style="font-weight: 500; padding: 1px 15px 1px 15px;">{{this.year}}</span>
        </v-flex>

    </v-layout>
    </div>
</template>

<script>
import formatCurrency from '../../filters/currencyformat';
import { COLOR_TYPE } from '../../modules/AppTheme';

export default {

    data() {
        return {

        };
    },

    props: {
        biztosito_id: {
            type: Number,
            required: true,
        },
        evesdij: {
            type: [String, Number],
            required: true,
        },
        gyakdij: {
            type: [String, Number],
            required: true,
        },
        year: {
            type: String,
            required: true,
        },
    },

    methods: {
        formatCurrency,

        olvashatoGyakorisag(fizutem) {
            switch (Number(fizutem)) {
            case 1:
                return 'hó';
            case 2:
                return 'negyedév';
            case 3:
                return 'félév';
            case 4:
                return 'év';
            case 5:
                return 'egyösszegű';
            default:
                throw new Error('olvashatoGyakorisag not implemented yet!');
            }
        },

        getEvNev() {
            return (Number(this.$store.getters.tarifaData.tarifa_fizetesi_utem) === 5) ? 'egyösszegű' : 'év';
        },

        getGyakNev() {
            return ` / ${this.olvashatoGyakorisag(this.$store.getters.tarifaData.tarifa_fizetesi_utem)}`;
        },

        getDijEzresek(dij) {
            return Math.floor(Math.floor(dij) / 1000);
        },

        getDijSzazasok(dij) {
            if (Number(dij) === 0) {
                return '';
            }
            return (Math.floor(dij) - Math.floor(Math.floor(dij) / 1000) * 1000).toString().padStart(3, '0');
        },

        getBalesetDijStyle() {
            return `background:${this.$theme.getColor(COLOR_TYPE.SECONDARY)};`
                + `color:${this.$theme.getColor(COLOR_TYPE.PRIMARY)};`;
        },
    },
};
</script>

<style scoped>
    .Xbaleset-dij-box {
        border-width: 2px;
        border-style: solid solid solid solid;
        border-color: #fbd389;
        border-radius: 4px;
        background: #ffe5b4;
        cursor: pointer;
        align-items: center;
    }

    .baleset-dij-box-fontsize {
        font-size: 14px;
        font-weight: bold;
    }

.baleset-dij-box {
    cursor: pointer;
    align-items: center;
    border-width: 2px;
    border-style: solid solid solid solid;
    border-radius: 2px;
    border-color: #fbd389;
    background: #ffe5b4;
    color: red;
}

.gyakorisagi-dij-text {
    font-weight: bold;
    font-size: 17px;
}

.szaz{
    position: relative;
    left: -5px;
    font-size: 20px;
}
.ezer {
    font-size: 33px;
    margin-right: 3px;
}

.evesdij-txt {
    font-weight: 400;
    font-size:13px;
}

.evesdij-text {
    position: relative;
    top: 0px;
}

.currency {
    font-weight: 400;
    letter-spacing: 0px;
    padding: 0;
    /*font-family: "Lato",sans-serif;*/
}

.yearly-fee-text {
    font-size: 19px;
}
</style>
